import { Injectable } from '@angular/core';

import { LocationRecurly } from '@shared/restaurant/models';
import { SubscriptionTypes } from '@shared/restaurant/enums';

@Injectable({ providedIn: 'root' })
export class PricePlansRestrictionsService {
  availableForStarterPlan(subscriptionType: SubscriptionTypes, recurlyData: LocationRecurly): boolean {
    if (subscriptionType === SubscriptionTypes.offline) {
      return true;
    }

    const { planCode } = recurlyData;
    return planCode.includes('starter') ||
      planCode.includes('basic') ||
      planCode.includes('reef') ||
      planCode.includes('standard') ||
      planCode.includes('business') ||
      planCode.includes('premium');
  }

  availableForBusinessPlan(subscriptionType: SubscriptionTypes, recurlyData: LocationRecurly): boolean {
    if (subscriptionType === SubscriptionTypes.offline) {
      return true;
    }

    const { planCode } = recurlyData;
    return planCode.includes('standard') ||
      planCode.includes('reef') ||
      planCode.includes('business') ||
      planCode.includes('premium');
  }
}
